import { createContext } from "react";

const defaultValue = {
  local: "English",
  setLocal: () => {},
};

export default createContext(defaultValue);
